import { RouteObject } from "react-router-dom";
import TributacaoView from "./Tributacao/Tributacao.View";
import TributacaoCadastroView from "./Tributacao/Cadastro/TributacaoCadastro.View";
import TributacaoCfopCadastroView from "./Cfop/TributacaoCfopCadastro.View";
import TributacaoCfopImpostoCadastroView from "./Imposto/TributacaoCfopImpostoCadastro.View";
import TributacaoCfopImpostoIBSCBSCadastroView from "./Imposto/IBSCBS/TributacaoCfopImpostoIBSCBSCadastro.View";

export const TributacaoRoutes: RouteObject[] = [
  {
    path: "fiscal/tributacao",
    element: <TributacaoView />,
  },
  {
    path: "fiscal/tributacao/cadastro",
    element: <TributacaoCadastroView />,
  },
  {
    path: "fiscal/tributacao/cfop/cadastro",
    element: <TributacaoCfopCadastroView />,
  },
  {
    path: "fiscal/tributacao/cfop/imposto/cadastro",
    element: <TributacaoCfopImpostoCadastroView />,
  },
  {
    path: "fiscal/tributacao/cfop/imposto/ibscbs/cadastro",
    element: <TributacaoCfopImpostoIBSCBSCadastroView />,
  },
];
